import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { NoiseOverlay } from "@/components/NoiseOverlay";
import HomeMenu from "@/pages/HomeMenu";
import DeckView from "@/pages/DeckView";
import OnePager from "@/pages/OnePager";

function App() {
  return (
    <AppProvider>
      <NoiseOverlay />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeMenu />} />
          <Route path="/deck/:mode" element={<DeckView />} />
          <Route path="/one-pager" element={<OnePager />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
